import { render } from "./UIKit.vue?vue&type=template&id=c53e92ee&scoped=true&ts=true"
import script from "./UIKit.vue?vue&type=script&lang=ts"
export * from "./UIKit.vue?vue&type=script&lang=ts"

import "./UIKit.vue?vue&type=style&index=0&id=c53e92ee&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53e92ee"]])

export default __exports__